import React, { useState } from 'react'

function Select({ options, onPropertySelected }) {
  const [selectedProperty, setSelectedProperty] = useState("")

  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    // Check if the selected value is empty, and set it to null if it is
    const updatedValue = selectedValue === "" ? null : selectedValue;

    setSelectedProperty(updatedValue);
    onPropertySelected(updatedValue); // Call the callback function with the selected property code
  
  };

  return (
    <select value={selectedProperty} onChange={handleSelectChange} className="relative -ml-px inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 focus:outline-none">
      <option value="">Sélectionnez une propriété</option>
      {options.map((property) => (
        <option key={property.id} value={property.code}>
          {property.name}
        </option>
      ))}
    </select>
  );
}

export default Select